import { Box, createStyles, makeStyles, Theme } from '@material-ui/core';
import { SearchComponent } from 'components/UI';
import { FunctionComponent, SetStateAction, useEffect, useRef, useState } from 'react';
import { reduceResolution, wbp } from 'Theme';
import Filters from '../../Search/Filters';

interface HeaderProps {
    onSearchText: (text: string) => void;
    onSelectFilter: (value: SetStateAction<string>) => void;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: 'flex',
            alignItems: 'center',
            height: '12%',
            width: '100%',
            [theme.breakpoints.down(wbp)]: {
                padding: `${reduceResolution(13)}px ${reduceResolution(13)}px ${reduceResolution(15)}px`
            },
            [theme.breakpoints.up(wbp)]: {
                padding: '13px 13px 15px'
            },
            backgroundColor: '#F1F1F1',
            borderBottom: '1px solid #D4D4D4'
        },
        search: {
            'height': 47,
            '& .MuiInputBase': {
                '&-root': {
                    'backgroundColor': '#fff',

                    '& svg': {
                        width: 16,
                        height: 16,
                        color: '#7A7A7A'
                    }
                },
                '&-input': {
                    fontSize: 14
                }
            }
        }
    })
);

export const Header: FunctionComponent<HeaderProps> = props => {
    const classes = useStyles();

    return (
        <Box className={classes.root}>
            <SearchComponent
                open={true}
                className={classes.search}
                placeholder="Search by number"
                onSearch={props.onSearchText}
            />
            <Filters onSelect={option => props.onSelectFilter(option)} />
        </Box>
    );
};

export default Header;
